import { clearGaUserType } from "./ga-user-type";
import { consumeVdItemListIds } from "./vd-item-list-ids";
import { consumeVdOrderFor } from "./vd-order-for";

// REV-125: drops the checkout attribution markers that only the purchase push consumes, for a Thank
// You Page that settles without a purchase, so they cannot leak into the next purchase in this tab.
export const clearVdCheckoutAttribution = (): void => {
  consumeVdItemListIds();
  clearGaUserType();
  consumeVdOrderFor();
};
